var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"chips",attrs:{"no-gutters":"","align-content":"start"}},_vm._l((_vm.chips),function(chip,i){return _c('v-col',{key:i,staticClass:"px-1",attrs:{"cols":"4"}},[_c('v-chip',_vm._b({staticClass:"text-uppercase"},'v-chip',_vm.config,false),[_vm._v(_vm._s(_vm.asText(chip)))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }